'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

const SESSION_KEY = 'refinity_session_id'

function getOrCreateSessionId(): string {
  if (typeof window === 'undefined') return ''
  let id = window.sessionStorage.getItem(SESSION_KEY)
  if (!id) {
    id = crypto.randomUUID()
    window.sessionStorage.setItem(SESSION_KEY, id)
  }
  return id
}

export default function PageViewTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!pathname) return
    const sessionId = getOrCreateSessionId()
    const query = searchParams?.toString()
    const path = query ? `${pathname}?${query}` : pathname

    void fetch('/api/track/pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        sessionId,
        path,
        referrer: document.referrer || '',
        timestamp: new Date().toISOString(),
      }),
    }).catch(() => {})
  }, [pathname, searchParams])

  return null
}
